import { HS3_DATA_SOURCE_TYPE } from '@/constants/data_sources';
import { HUBSPOT_EXPORT_SCOPE } from '@/constants/feature_flags';
import { useFeatureFlagStore } from '@/stores';

const CRM_EXPORT_SCOPE = 'crm.export';

type OptionalScopesPayloadType = { optional_scopes?: string[] };

/**
 * `crm.export` unlocks HubSpot's Exports API. Only a HubSpot Super Admin can
 * grant it, so it is requested as an optional scope: HubSpot silently drops it
 * when the installing user cannot grant it rather than failing the install.
 *
 * The authorize endpoint takes a closed schema, so the key must be absent
 * entirely - not empty or undefined - whenever we are not asking for it.
 */
export default function useHubspotExportScope() {
  const { hasFeatureFlag } = useFeatureFlagStore();

  function optionalScopesFor(
    integrationType?: string | null,
  ): OptionalScopesPayloadType {
    const isExportScopeRequestable =
      integrationType === HS3_DATA_SOURCE_TYPE &&
      hasFeatureFlag(HUBSPOT_EXPORT_SCOPE);
    return isExportScopeRequestable
      ? { optional_scopes: [CRM_EXPORT_SCOPE] }
      : {};
  }

  return { optionalScopesFor };
}
